import React from 'react';
import {translate} from '../../utils/localization-utils';

interface TitleProps {
	keyValue: string;
	customClass?: string;
}

export default function Title({ keyValue, customClass }: TitleProps) {
	return (
		<h1 className={`text-[22px] text-blue ${customClass}`}>{translate(keyValue)}</h1>
	);
}
